import { TaskFilterConstDefault, TreeFilterConstDefault, TreeInspectionConstDefault } from '@/consts/Filters'

const state = {
  tasks: JSON.parse(JSON.stringify(TaskFilterConstDefault)),
  trees: JSON.parse(JSON.stringify(TreeFilterConstDefault)),
  treeInspections: JSON.parse(JSON.stringify(TreeInspectionConstDefault))
}

const mutations = {
  RESET_TASK_FILTER(state){
    state.tasks = JSON.parse(JSON.stringify(TaskFilterConstDefault))
  },
  SET_TASK_FILTER(state, {filter, value}) {
    if (Object.keys(state.tasks).includes(filter))
      state.tasks[filter] = value;
    else
      console.error(`Task filter with key: ${filter} does not exist!`);
  },
  RESET_TREE_FILTER(state){
    state.trees = JSON.parse(JSON.stringify(TreeFilterConstDefault))
  },
  SET_TREE_FILTER(state, {filter, value}) {
    if (Object.keys(state.trees).includes(filter))
      state.trees[filter] = value;
    else
      console.error(`Tree filter with key: ${filter} does not exist!`);
  },
  RESET_TREE_INSPECTION_FILTER(state){
    state.treeInspections = JSON.parse(JSON.stringify(TreeInspectionConstDefault))
  },
  SET_TREE_INSPECTION_FILTER(state, {filter, value}) {
    if (Object.keys(state.treeInspections).includes(filter))
      state.treeInspections[filter] = value;
    else
      console.error(`Tree inspection filter with key: ${filter} does not exist!`);
  }
}

const actions = {
  resetTaskFilters({ commit }) {
    commit('RESET_TASK_FILTER');
  },
  setTaskFilter({ commit }, {filter, value}) {
    commit('SET_TASK_FILTER', {filter, value});
  },
  resetTreeFilters({ commit }) {
    commit('RESET_TREE_FILTER');
  },
  setTreeFilter({ commit }, {filter, value}) {
    commit('SET_TREE_FILTER', {filter, value});
  },
  resetTreeInspectionFilters({ commit }) {
    commit('RESET_TREE_INSPECTION_FILTER');
  },
  setTreeInspectionFilter({ commit }, {filter, value}) {
    commit('SET_TREE_INSPECTION_FILTER', {filter, value});
  }
}

const getters = {
  getTaskFilters: state => state.tasks,
  getTreesFilters: state => state.trees,
  getTreesInspectionsFilters: state => state.treeInspections
}

export default {
  state,
  mutations,
  actions,
  getters
}
